// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".progress-styling[data-v-f3551d1c]{max-width:70%}\n", ""]);
// Exports
module.exports = exports;
